import * as actionTypes from "../ActionTypes";

const INITIAL = {
  data: {
    languageHeadings: [],
    languageList: [],
    languagePreferred: "",
    currentLanguageTitles: [],
    loginHardBlocker: false,
    userProfileDetails: {},
    hoveredActiveItem: {},
    hoveredActiveItem: {},
    maincarousel: [],
  },
};

const languageReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_PROFILE_DETAILS:
      return {
        ...state,
        data: { ...state.data, userProfileDetails: action.payload },
      };
    case actionTypes.LANGUAGE_DATA:
      return {
        ...state,
        data: { ...state.data, languageHeadings: action.payload },
      };
    case actionTypes.LANGUAGE_LIST:
      return {
        ...state,
        data: { ...state.data, languageList: action.payload },
      };
    case actionTypes.LANGUAGE_PREFERRED:
      return {
        ...state,
        data: { ...state.data, languagePreferred: action.payload },
      };
    case actionTypes.LANGUAGE_CURRENT:
      return {
        ...state,
        data: { ...state.data, currentLanguageTitles: action.payload },
      };
    case actionTypes.LOGIN_HARD_BLOCKER:
      return {
        ...state,
        data: { ...state.data, loginHardBlocker: action.payload },
      };
    case actionTypes.HOVERED_ACTIVE_ITEM:
      return {
        ...state,
        data: { ...state.data, hoveredActiveItem: action.payload },
      };
    case actionTypes.MAIN_CAROUSEL_DATA:
      return {
        ...state,
        data: { ...state.data, maincarousel: action.payload },
      };
    default:
      return state;
  }
};

export default languageReducer;
